import React, { Component } from 'react';
import { getFileName } from '../../../helpers/FileCaching';
import classes from './AddToHome.module.scss';
import {isMobileSafari} from 'react-device-detect';


const globalImages = require.context('../../../images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);

class AddToHome extends Component {

    
    constructor(props) {
        super(props);
        this.globalImages = this.props.globalImages;
        this.state={
            showAddToHome:true
        }
        
    }

    operation(){
        this.setState({showAddToHome:false});
        localStorage.setItem('showAddToHome', 'false') 
    } 

    render() {
        if (isMobileSafari && localStorage.showAddToHome!='false')
         {
            if (window.navigator.standalone == false){
                return (
                    <div className={classes.add_to_home} >
                        <div className={classes.add_to_home__background_col}></div>
                        {
                            
                            this.state.showAddToHome?
                             <img className={classes.add_to_home__img} onClick={()=>this.operation()} alt="add to home" src={getFileName(globalImages, 'add-to-home.svg')} onError="this.src='{getFileName(globalImages, 'add-to-home.png')}'"/>
                                :null
                        }
                    </div>
                )
            } 
        }

        return (
        
            null
        )
    
        }
    
}

export default AddToHome;
